import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { IntegrationsTab } from 'modules/integrations/ui/pages';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { TabMenu } from 'ud-ui/components/tab-menu';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import Account from './tabs/account';
import Interface from './tabs/interface';
import Profile from './tabs/profile/profile';
import SocialNet from './tabs/social-net/social-net';
import Subscription from './tabs/subscription/subscription';

interface SettingsTab {
  /** Дескриптор, а не строка: константа модуля считается до выбора языка, переводится в рендере. */
  name: MessageDescriptor;
  /** Адрес вкладки из `Pages`. */
  path: string;
  /** Хвост адреса, по которому вкладка считается активной; у первой его нет. */
  match?: string;
}

const TABS: SettingsTab[] = [
  { name: msg`Профиль`, path: Pages.SETTINGS.INDEX },
  { name: msg`Ссылки`, path: Pages.SETTINGS.SOCIAL_NET, match: '/social-net' },
  { name: msg`Интеграции`, path: Pages.SETTINGS.INTEGRATIONS, match: '/integrations' },
  { name: msg`Подписка`, path: Pages.SETTINGS.SUBSCRIPTION, match: '/subscription' },
  { name: msg`Личный кабинет`, path: Pages.SETTINGS.ACCOUNT, match: '/account' },
  { name: msg`Интерфейс`, path: Pages.SETTINGS.INTERFACE, match: '/interface' },
];

const SettingsPage = () => {
  const { t } = useLingui();
  const { setHeaderContent } = useMainLayout();
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = useMemo(() => {
    const index = TABS.findIndex((tab) => tab.match && location.pathname.includes(tab.match));

    return index === -1 ? 0 : index;
  }, [location.pathname]);

  useEffect(() => {
    setHeaderContent(
      <UDHeaderTitle>
        <Trans>Настройки</Trans>
      </UDHeaderTitle>,
    );

    return () => {
      setHeaderContent(null);
    };
  }, [setHeaderContent]);

  const changeTab = (tab: number) => {
    navigate(TABS[tab]?.path ?? Pages.SETTINGS.INDEX);
  };

  return (
    <>
      {/* Заголовок «Информация об организаторе» переехал во вкладку «Профиль»: над кабинетом он неверен. */}
      <div className="pt-6">
        <TabMenu tabs={TABS.map((tab) => ({ name: t(tab.name), active: true }))} activeTab={activeTab} onChange={changeTab} />
      </div>
      <div className="w-full px-6 py-6">
        <Routes>
          <Route path="/" element={<Profile />} />
          <Route path="/social-net" element={<SocialNet />} />
          <Route path="/integrations" element={<IntegrationsTab />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/account" element={<Account />} />
          <Route path="/interface" element={<Interface />} />
        </Routes>
      </div>
    </>
  );
};

export default SettingsPage;
